import { useState, useEffect } from 'react';
import { UserOutlined, TransactionOutlined } from '@ant-design/icons';
import { Tabs, Space } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import axios from 'axios';
import Tab1 from './Tab1';
//import Utilisateur from '../../../../../../Models/Utilisateur';
import Utilisateur from '../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import Data from '../../../Data/Data.json'

import SweetAlert from "sweetalert2"
import { Crypter } from '../../../Functions/Security/Crypter';
import { Typography } from '@mui/material';
import Tab2 from './Tab2';
import Operation from '../../../Models/Operation';
import ReformatNumber from '../../../Functions/Traitement/ReformatNumber';
import formatNumber from '../../../Functions/Traitement/FormatNumber';
import DataHistoCpt from '../../../Types/DataHistoCpt';
import VerifDay from '../../../Functions/Traitement/VerifDay';
import { useNavigate } from 'react-router-dom';

//import '../../../Assets/Styles/StyleForm.css';
//CreateNewCLIENT
const Swal = require('sweetalert2');

const TransfertCptToCptDistant = () => {
    // USER SESSION
    const auth = useAuthUser()
    const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

    // USER TOKEN
    const authHeader = useAuthHeader()

    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [StartSearchG, SeStartSearchG] = useState(false);
    const [StartForm, SetStartForm] = useState(true);
    const [, forceUpdate] = useState({});
    const [isSubmit, setIsSubmit] = useState(false)
    const [ajoutActve, setAjoutActif] = useState(false)
    const [modifActve, setModifActve] = useState(true)
    const [enregActve, setEnregActve] = useState(true)
    const [consulActive, setConsulActive] = useState(false)
    const [sbmit, setSbmit] = useState("");
    const [DataOperation, setDataOperation] = useState<DataHistoCpt[]>([]);
    const [DataOperationV, setDataOperationV] = useState<DataHistoCpt[]>([]);
    const Navigate = useNavigate();
    const [annulActive, setAnnulActive] = useState(true);
    const [StartRef, SetStartRef] = useState(false);

    useEffect(() => {
        forceUpdate({});
        if (StartForm == true) {
            VerifDay(user.coduti, user.codage, authHeader, Navigate);
            GetAllOperation();
            SetStartForm(false);
        }
    }, []);

    function initialiazeButton() {
        setAjoutActif(false)
        setModifActve(true)
        setEnregActve(true)
        setConsulActive(false)
    }

      function handleAnulle() {
            SetStartRef(false)
            let REF = form.getFieldValue("Reference")
            form.resetFields()
            localStorage.clear()
            setDataOperation([])
            initialiazeButton()
            localStorage.setItem(Data.LocalVariable.reset, "1")
            SeStartSearchG(false)
            form.setFieldValue("Reference", REF)
        }
    
    const SetStart = async () => {

   
        let data = Crypter.encrypt('1');
        let data2 = Crypter.encrypt(user.codage);
        let data3 = Crypter.encrypt(user.codage);
        let data4 = Crypter.encrypt(user.codage);
        setAnnulActive(false);
        SetStartRef(true);
        setLoading(true)

        if (data.length != 0) {

            form.resetFields();

            setLoading(true);


            form.setFieldsValue({ "CodeOpe": '', "lib_CodeOpe": '', "LibelleEm": '', 'DISPONEM': '', 'CodeOpeRECP': '', 'LibelleRecep': '' })

            let config1 = {
                method: 'get',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.GetReference,
                headers: {
                     'CypherStaOp': data4,
                    'CypherRefOp': data3,
                    'CypherCodAge': data2,
                    'CypherTypOp': data,
                    'Authorization': authHeader(),
                    'Content-Type': 'application/json'
                },
            }


            let config2 = {
                method: 'get',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.GetGetCodeOperat,
                headers: {
                    'CypherChampOpe': Crypter.encrypt('OPE009'),
                    'Authorization': authHeader(),
                    'Content-Type': 'application/json'
                },
            };

            let requestOne = axios.request(config1);
            let requestTwo = axios.request(config2);

            await axios
                .all([requestOne, requestTwo])
                .then(
                    await axios.spread(async (...responses: any) => {

                        const responseOne = responses[0];
                        const responseTwo = responses[1];

                        if (responseOne.data) {
                            const res = JSON.parse(Crypter.decrypt(responseOne.data)).Value;
                            if (res.StatutCode == 200) {

                                form.setFieldValue("Reference", res.Result);
                                setSbmit("add");
                                setAjoutActif(true);
                                setEnregActve(false);

                                if (responseTwo.data) {
                                    const res = JSON.parse(Crypter.decrypt(responseTwo.data)).Value;
                                    if (res.StatutCode == 200) {
                                        let datas = res.Result[0];
                                        form.setFieldsValue({
                                            "CodeOpeEm": datas.OPE009,
                                            "lib_CodeOpeEm": datas.LIBELL,
                                            "CodeOpeReCpt": datas.OPE009,
                                            "lib_CodeOpeReCpt": datas.LIBELL
                                        })
                                    }
                                    else {
                                        setLoading(false);
                                        SweetAlert.fire({ title: "error", text: res.Message, icon: "error" })
                                    }

                                    setConsulActive(true)
                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        }
                    }
                    )).catch((errors) => {
                        SweetAlert.fire({ title: "error", text: errors.message, icon: "error" })
                    });

            setLoading(false);
        }
    }

    const GetAllOperation = async () => {
        setLoading(true);
        setDataOperation([]);

        var config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.GetOperation,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authHeader(),
                'CypherFilter': Crypter.encrypt('2'),
                'CypherCodeA': Crypter.encrypt(user.codage),
                'CypherCodeU': Crypter.encrypt(user.coduti),
                'CypherRepec': Crypter.encrypt('')
            }
        };

        await
            axios(config)
                .then((response) => {
                    //alert('ok')
                    if (response.data) {
                        const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                        if (res.StatutCode == 200) {
                            let datas = res.Result;

                            const Datat: DataHistoCpt[] = [];
                            if (datas.length === 0) {
                                //console.log("aucun élément ");
                            }
                            else {

                                let TotalDebit: number = 0;
                                let TotalCrebit: number = 0;
                                let NbrCrebit: number = 0;
                                let Nbrdebit: number = 0;

                                res.Result.map((data: any, indice: number) => {

                                    if (data.SENSEC == "D") { Nbrdebit++; TotalDebit += data.MONTAN; }
                                    else { NbrCrebit++; TotalCrebit += data.MONTAN; }

                                    Datat.push({
                                        key: indice,
                                        NUMCPT: data.NODUCP,
                                        DATOPE: (new Date(data.DATOPE.substring(0, 10))).toLocaleDateString("fr"),
                                        TIME: data.TIME.substring(11,),
                                        DEDEVR: (new Date(data.DEDEVR.substring(0, 10))).toLocaleDateString("fr"),
                                        SENSEC: data.SENSEC,
                                        REPECE: data.REPECE,
                                        NUMRAP: data.NUMRAP,
                                        REFLIAI: data.REFLIAI,
                                        LIBELL: data.LIBELL,
                                        MONTANT: formatNumber(data.MONTAN ? data.MONTAN : ''),
                                        MONTANTDEBIT: formatNumber(data.MONTANT ? data.MONTANT : ''),
                                        MONTANTCREDIT: formatNumber(data.MONTANT ? data.MONTANT : ''),
                                        SOLDT: formatNumber(TotalDebit + TotalCrebit),
                                        NBENEF: data.NBENEF,
                                        UTISAI: data.UTISAI
                                    });
                                })

                                setDataOperation(Datat);
                                form.setFieldValue("TotalDebitOP", formatNumber(TotalDebit));
                                form.setFieldValue('TotalCrebitOP', formatNumber(TotalCrebit));
                                form.setFieldValue("NbrCrebitOP", NbrCrebit);
                                form.setFieldValue("NbrdebitOP", Nbrdebit);
                                form.setFieldValue("SoldeOP", formatNumber(TotalCrebit - TotalDebit));
                                form.setFieldValue("NbrTotalOP", NbrCrebit + Nbrdebit);
                            }
                        }
                        setLoading(false);
                    }
                    //  setLoad(false);
                }).catch((error) => {

                    SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
                })
        setLoading(false);
    }

    const GetAllOperationV = async () => {

        setLoading(true);
        setDataOperationV([]);

        var config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.GetOperation,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authHeader(),
                'CypherFilter': Crypter.encrypt('3'),
                'CypherCodeA': Crypter.encrypt(user.codage),
                'CypherCodeU': Crypter.encrypt(user.coduti),
                'CypherRepec': Crypter.encrypt('')

            }
        };

        await
            axios(config)
                .then((response) => {
                    //alert('ok')
                    if (response.data) {
                        const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                        if (res.StatutCode == 200) {
                            let datas = res.Result;

                            const Datat: DataHistoCpt[] = [];
                            if (datas.length === 0) {
                                //console.log("aucun élément ");
                            }
                            else {

                                let TotalDebit: number = 0;
                                let TotalCrebit: number = 0;
                                let NbrCrebit: number = 0;
                                let Nbrdebit: number = 0;

                                res.Result.map((data: any, indice: number) => {
                                    if (data.SENSEC == "D") { Nbrdebit++; TotalDebit += data.MONTAN; }
                                    else { NbrCrebit++; TotalCrebit += data.MONTAN; }

                                    Datat.push({
                                        key: indice,
                                        NUMCPT: data.NODUCP,
                                        DATOPE: (new Date(data.DATOPE.substring(0, 10))).toLocaleDateString("fr"),
                                        TIME: data.TIME.substring(11,),
                                        DEDEVR: (new Date(data.DEDEVR.substring(0, 10))).toLocaleDateString("fr"),
                                        SENSEC: data.SENSEC,
                                        REPECE: data.REPECE,
                                        NUMRAP: data.NUMRAP,
                                        REFLIAI: data.REFLIAI ? data.REFLIAI : '',
                                        LIBELL: data.LIBELL,
                                        MONTANT: formatNumber(data.MONTAN ? data.MONTAN : ''),
                                        MONTANTDEBIT: formatNumber(data.MONTANT ? data.MONTANT : ''),
                                        MONTANTCREDIT: formatNumber(data.MONTANT ? data.MONTANT : ''),
                                        SOLDT: formatNumber(TotalDebit + TotalCrebit),
                                        NBENEF: data.NBENEF,
                                        UTIVAL: data.UTIVAL,
                                        UTISAI: data.UTISAI
                                    });
                                })

                                setDataOperationV(Datat);
                                form.setFieldValue("TotalDebit", formatNumber(TotalDebit));
                                form.setFieldValue('TotalCrebit', formatNumber(TotalCrebit));
                                form.setFieldValue("NbrCrebit", NbrCrebit);
                                form.setFieldValue("Nbrdebit", Nbrdebit);
                                form.setFieldValue("Solde", formatNumber(TotalCrebit - TotalDebit));
                                form.setFieldValue("NbrTotal", NbrCrebit + Nbrdebit);
                            }
                        }
                        setLoading(false);
                    }
                    //  setLoad(false);
                }).catch((error) => {

                    SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
                })
        setLoading(false);
    }
    //Tab2
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <span id='Tab'>
                    <UserOutlined />
                    Virements distants
                </span>
            ),
            children: <Tab1 etatG={StartRef} form={form} DataOperation={DataOperation} GetAllOperation={GetAllOperation} />,
        },
        {
            key: '2',
            label: (
                <span id='Tab'>
                    <TransactionOutlined />
                    Virements distants
                </span>
            ),
            children: <Tab2 form={form} DataOperation={DataOperationV} />,
        }
    ]

    const onFinish = (values: any) => {

        let Operation: Operation = values;
        Operation.aeducp = user.codage;
        Operation.codope = form.getFieldValue('CodeOpeEm');
        Operation.exoner = '';
        Operation.montant = form.getFieldValue('Montant');
        // Operation.devis='XAF';
        Operation.taux = 0;
        Operation.sensec = '';
        Operation.datval = '';
        Operation.codanal = '';
        Operation.libanal = '';
        Operation.refauto = form.getFieldValue('Reference');
        Operation.refmanuel = form.getFieldValue('NumPiece');
        Operation.line = 0;
        Operation.codserv = '';
        Operation.datsys = '';
        Operation.nbenef = '';
        Operation.datope = (new Date(user.datjour)).toLocaleDateString("fr").replaceAll("/", '-');
        Operation.numcpt = '';
        Operation.annee = user.datjour.substring(0, 4);
        Operation.mois = user.datjour.substring(5, 7);
        Operation.litige = '';
        Operation.utisai = user.coduti;
        Operation.typope = '1';
        Operation.ImportSai = [];
        // Client.DateDelcni = Client.DateDelcni? (new Date(Client.DateDelcni)).toLocaleDateString("fr").replaceAll('/', '-')+" 00:00:00" : ""
        // Client.DATNAI = (new Date(Client.DATNAI)).toLocaleDateString("fr").replaceAll('/', '-')+" 00:00:00"

        let dispon = ReformatNumber(form.getFieldValue('DISPONEM')).toString();

        if (sbmit == "add") {
            // if (form.getFieldValue('Montant')<ReformatNumber(form.getFieldValue('DISPONEM'))) {
            SweetAlert.fire({
                title: "Virement Compte à Compte",
                text: "Voulez-vous transferer " + formatNumber(form.getFieldValue('Montant')) + ' XAF ' + " de : " + form.getFieldValue('NUMCPTEMT') + '-' + form.getFieldValue('lib_NUMCPTEMT') + " Vers : " + form.getFieldValue('NUMCPTRECPT') + '-' + form.getFieldValue('lib_NUMCPTRECPT') + " ? ",
                showCancelButton: true,
                color: "green",
                confirmButtonText: "Yes",
                confirmButtonColor: "green",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: 'question'
            }).then((res) => {
                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)
                    //let group = profilsDistant.find(()=>)
                    //console.log('Received values of form: ', Crypter.encrypt(JSON.stringify(Client)));

                    let data = Crypter.encrypt(JSON.stringify(Operation));

                    let config = {
                        method: 'post',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.SaisieOperation,
                        headers: {
                            'Accept': '*/*',
                            'cypherNumcptEm': Crypter.encrypt(form.getFieldValue('NUMCPTEMT')),
                            'cypherLibEm': Crypter.encrypt(form.getFieldValue('lib_CodeOpeEm')),
                            'cypheNumcptRecpt': Crypter.encrypt(form.getFieldValue('NUMCPTRECPT')),
                            'cypherLibRecpt': Crypter.encrypt(form.getFieldValue('lib_CodeOpeReCpt')),
                            'cypherDispon': Crypter.encrypt(dispon),
                            'cypherOption': Crypter.encrypt('1'),
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                                if (res.StatutCode == 200) {
                                    let result = res.Result;
                                    form.resetFields();
                                    localStorage.clear();
                                    setIsSubmit(false);

                                    SweetAlert.fire({ title: res.Message, text: result, icon: "success" })

                                    localStorage.clear();
                                    initialiazeButton();

                                    setSbmit("");

                                    GetAllOperation();
                                }
                                else {
                                    SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
                        });
                }
            })
            // } else {
            //     SweetAlert.fire({ title: "Solde Invalide", text: "Le Montant disponible de " + form.getFieldValue('NUMCPTEMT') + " : " + form.getFieldValue('lib_NUMCPTEMT') + " est insuffisant", icon: "error" })
            // }
        }
    };

    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        })
        SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
    };

    const consult = async () => {

        setLoading(true);
        setDataOperation([]);

        let Repec = form.getFieldValue('Reference');
        var data = { CodeAgence: "", Table: "ECPTAMPON", Colonne1: "REPECE", Colonne2: '', Colagence: '', Init: Repec, choix: 33 }
        var config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.AnySearch,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authHeader(),
                'CypherSearch': Crypter.encrypt(JSON.stringify(data))
            }
        };

        await
            axios(config)
                .then((response) => {
                    //alert('ok')
                    if (response.data) {
                        const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                        if (res.StatutCode == 200) {
                            let datas: [] = res.Result.Table;

                            const Datat: DataHistoCpt[] = [];
                            if (datas.length === 0) {
                                alert(JSON.stringify(res))
                                //console.log("aucun élément ");
                            }
                            else {
                                let TotalDebit: number = 0;
                                let TotalCrebit: number = 0;
                                let NbrCrebit: number = 0;
                                let Nbrdebit: number = 0;

                                res.Result.Table.map((data: any, indice: number) => {

                                    if (data.SENSEC == "D") { Nbrdebit++; TotalDebit += data.MONTAN; }
                                    else { NbrCrebit++; TotalCrebit += data.MONTAN; }

                                    Datat.push({
                                        key: indice,
                                        NUMCPT: data.NODUCP,
                                        DATOPE: (new Date(data.DATOPE.substring(0, 10))).toLocaleDateString("fr"),
                                        TIME: data.TIME.substring(11,),
                                        DEDEVR: (new Date(data.DEDEVR.substring(0, 10))).toLocaleDateString("fr"),
                                        SENSEC: data.SENSEC,
                                        REPECE: data.REPECE,
                                        NUMRAP: data.NUMRAP,
                                        LIBELL: data.LIBELL,
                                        MONTANT: formatNumber(data.MONTAN ? data.MONTAN : ''),
                                        MONTANTDEBIT: formatNumber(data.MONTANT ? data.MONTANT : ''),
                                        MONTANTCREDIT: formatNumber(data.MONTANT ? data.MONTANT : ''),
                                        SOLDT: formatNumber(TotalDebit + TotalCrebit),
                                        NBENEF: data.NBENEF,
                                        UTISAI: data.UTISAI,
                                        REFLIAI: data.REFLIAI
                                    });

                                    setDataOperation(Datat);
                                    form.setFieldValue("TotalDebitOP", formatNumber(TotalDebit));
                                    form.setFieldValue('TotalCrebitOP', formatNumber(TotalCrebit));
                                    form.setFieldValue("NbrCrebitOP", NbrCrebit);
                                    form.setFieldValue("NbrdebitOP", Nbrdebit);
                                    form.setFieldValue("SoldeOP", formatNumber(TotalCrebit - TotalDebit));
                                    form.setFieldValue("NbrTotalOP", NbrCrebit + Nbrdebit);
                                })

                            }
                        }
                        setLoading(false);
                    }
                    //  setLoad(false);
                }).catch((error) => {
                    SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
                })
    }

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'><b>{window.location.pathname} </b></Typography>
            <Spin spinning={loading} size='large' style={{ color: 'green' }} >
                <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={consulActive} onClick={consult} type="ghost" htmlType="button" block  >
                                    Consulter
                                </Button>
                                <Button size='large' className='bt_add' disabled={ajoutActve} onClick={SetStart} type="ghost" htmlType="button" block  >
                                    Ajouter
                                </Button>
                                <Button size='large' className='bt_add' disabled={enregActve} type="ghost" htmlType="submit" block>
                                    Enregistrer
                                </Button>
                                
                                <Button size='large' disabled={annulActive} onClick={handleAnulle} className='bt_add' type="ghost" htmlType="reset" block>
                                    Annuler
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div >
                            <Tabs size='large' type="card" onChange={(e) => { if (e == '2') { GetAllOperationV(); } }} defaultActiveKey="1" items={items} />
                        </div>
                        <div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>

    );
}
export default TransfertCptToCptDistant;